import { computed } from 'vue'
import type { ComputedRef } from 'vue'
// types
import type { StrapiStatsItem } from '@ts-strapi/interfaces'

export const GLOBAL_STATS_STATE_KEY = 'strapi:cta-settings-stats'

// The site-wide default stats every section set to the global source renders. The
// items are fetched from the "Settings CTA" single type into useState by
// useStrapiCtaSettings (awaited in the layout); until they arrive — or when the
// single type is empty — sections fall back to an empty list (hidden by showStatsBar).
export const useGlobalStats = (): ComputedRef<StrapiStatsItem[]> => {
  const refGlobalStats = useState<StrapiStatsItem[]>(GLOBAL_STATS_STATE_KEY, () => [])

  return computed<StrapiStatsItem[]>(() => refGlobalStats.value ?? [])
}
